import React from "react";
import "./offersection.css";
import { Link } from "react-router-dom";

const OfferSection = () => {
  return (
    <div>
      <div className="open-hours">
        <div className="home-open-text">
          <h2 className="open-bold">OPEN 7 DAYS</h2>
          <h4 className="open-time">
           Mon–Tue: 6 AM–5 PM | Wed–Sat: 6 AM–8 PM | Sun: 8 AM–12 PM
          </h4>
        </div>
        <div>
          <Link to="/view-our-menu" className="view-menu-btn">
            VIEW MENU
          </Link>
        </div>
      </div>

      <section className="offer-image-section">
        <h2 className="offer-title">OFFERS</h2>
        <div className="offer-image-wrapper">
          <img
            src="/Images/offer-1.png"
            alt="BOGO Offer"
            className="offer-full-image"
            loading="lazy"
          />
        </div>
        <div className="offer-btn-wrapper">
          <Link to="/mandurah-cafe-offers" className="offer-button">
            EXPLORE ALL OFFERS
          </Link>
        </div>
      </section>
    </div>
  );
};

export default OfferSection;
